window.NotificationCenterAPI = new (function () {
    var self = this;
    var _protected = BaseAPI.call(self);
    _protected.setApiUrl(publicConfiguration.NotificationCenterServers);

    self.getEmailsAndPushNotificationsSettings = function (brandId) {

        _protected.setApiUrl(publicConfiguration.NotificationCenterServersV2);
        var defer = $q.defer();

        _protected.request('brands/' + brandId + '/settings/notifications/teamlive', 'GET')
            .then(function (response) {

                if (response && response.data && response.data.data && response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            })
            .catch(function (error) {
                defer.reject(error);
            });
        _protected.setApiUrl(publicConfiguration.NotificationCenterServers);

        return defer.promise;
    };

    self.updateEmailsAndPushNotificationsSettings = function (brandId, notificationSettings) {

        _protected.setApiUrl(publicConfiguration.NotificationCenterServersV2);
        var defer = $q.defer();

        _protected
            .request('brands/' + brandId + '/settings/notifications/teamlive', 'PUT', notificationSettings)
            .then(function (response) {
                if (response.status === 200) {
                    defer.resolve(response.data.data);
                } else {
                    defer.reject(response);
                }
            })
            .catch(function (error) {
                defer.reject(error);
            });

        _protected.setApiUrl(publicConfiguration.NotificationCenterServers);

        return defer.promise;
    };
});
